import { bind } from '@react-rxjs/core';
import { createSignal } from '@react-rxjs/utils';
import { catchError, filter, from, map, Observable, of, switchMap, tap } from 'rxjs';

type BeforeInstallEvent = Event & { prompt: () => void; userChoice: Promise<'accepted' | 'dissmissed'> };

export const [useBeforeInstall, beforeInstall$] = bind(
  new Observable<BeforeInstallEvent>((subscriber) => {
    window.addEventListener('beforeinstallprompt', (e) => {
      e.preventDefault();
      subscriber.next(e as BeforeInstallEvent);
    });
  }),
  null
);

export const [install$, install] = createSignal();

const installPrompt$: Observable<boolean> = beforeInstall$.pipe(
  filter(Boolean),
  switchMap((e) =>
    install$.pipe(
      tap(() => {
        e.prompt();
      }),
      switchMap(() =>
        from(e.userChoice).pipe(
          map((choise) => (choise === 'accepted' ? true : false)),
          catchError(() => of(false))
        )
      )
    )
  )
);

export const [useInstall, prompt$] = bind(installPrompt$, false);
